import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CapabilitiesResponseDataSchema } from "schema"
import z from "zod"

type Response = {
  data: z.infer<typeof CapabilitiesResponseDataSchema>
}

type Props = {
  campaignId: string
}

const getCampaignCapabilitiesQueryKey = (campaignId: string) => [
  "capabilities",
  "campaign",
  campaignId,
]

export const campaignCapabilitiesQuery = ({ campaignId }: Props) => {
  return queryOptions({
    queryKey: getCampaignCapabilitiesQueryKey(campaignId),
    queryFn: async () => {
      const response = await axios.get<Response>("/capabilities", {
        params: { campaignId },
      })

      return response.data.data
    },
  })
}
